import { render, staticRenderFns } from "./CustomeServicePopup.vue?vue&type=template&id=233e4773&scoped=true"
import script from "./CustomeServicePopup.vue?vue&type=script&lang=js"
export * from "./CustomeServicePopup.vue?vue&type=script&lang=js"
import style0 from "./CustomeServicePopup.vue?vue&type=style&index=0&id=233e4773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233e4773",
  null
  
)

export default component.exports